<!--
 * @Author: wzc
 * @Date: 2021-12-15 10:39:41
 * @LastEditors: wzc
 * @LastEditTime: 2021-12-15 16:48:31
 * 播出单 横向切换播出单列表， swiper 实现
-->
<template>
  <div class="swiper_broadcastList">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide
        v-for="(groupItem, groupIndex) in dateList"
        :key="groupIndex"
      >
        <div
          class="date_item"
          v-for="item in groupItem.dayArr"
          :key="item.id"
          :class="item.isAct ? 'act' : ''"
          @click="clickItem(item)"
        >
          <span class="date_item_main">
            <span class="itemMain_matchName" v-text="item.name"></span>
            <span
              class="itemMain_themeNum"
              v-text="`${item.themeNum}个主题`"
            ></span>
            <span class="itemMain_opareBtnRow">
              <span class="opareBtnRow_left">
                <span
                  class="opareBtnRow_shareIcon"
                  :class="
                    currGroupOptMap &&
                    currGroupOptMap.playerItemId &&
                    currGroupOptMap.playerItemId === item.id
                      ? 'act'
                      : ''
                  "
                >
                  <span
                    class="iconBox"
                    @click.stop="shareItem('shareItem', item)"
                  >
                    <!-- <svg
                      t="1700107490969"
                      class="svg_icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6767"
                      width="95%"
                      height="95%"
                    >
                      <path
                        d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                        p-id="6768"
                      ></path>
                    </svg> -->
                    <svg
                      t="1700214936257"
                      class="svg_icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="10103"
                      width="90%"
                      height="90%"
                    >
                      <path
                        d="M-31.315747 519.457481m54.305801-54.305801l45.435853-45.435854q54.305801-54.305801 108.611601 0l303.931466 303.931466q54.305801 54.305801 0 108.611601l-45.435854 45.435853q-54.305801 54.305801-108.611601 0l-303.931465-303.931465q-54.305801-54.305801 0-108.611601Z"
                        p-id="10104"
                      ></path>
                      <path
                        d="M898.357541 105.745969m54.305801 54.305801l45.797892 45.797892q54.305801 54.305801 0 108.611602l-563.332174 563.332173q-54.305801 54.305801-108.611602 0l-45.797892-45.797892q-54.305801-54.305801 0-108.611601l563.332174-563.332174q54.305801-54.305801 108.611602 0Z"
                        p-id="10105"
                      ></path>
                    </svg>
                  </span>
                </span>
                <span
                  class="opareBtnRow_shareText"
                  v-text="'分享到此播单'"
                ></span>
              </span>
              <span class="opareBtnRow_right">
                <span
                  class="iconBox"
                  @click.stop="editItem('eidtSingleItem', item)"
                >
                  <svg
                    t="1700212308412"
                    class="svg_icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7759"
                    width="90%"
                    height="90%"
                  >
                    <path
                      d="M775.84 392.768l-155.2-172.352L160.768 643.264l-38.368 187.936 190.56-12.832zM929.952 229.952l-131.2-150.944-0.288-0.32a16 16 0 0 0-22.592-0.96l-131.168 120.576 155.168 172.352 128.832-118.464a15.936 15.936 0 0 0 1.248-22.24zM96 896h832v64H96z"
                      p-id="7760"
                    ></path>
                  </svg>
                </span>
              </span>
            </span>
            <span class="itemMain_removeBtn" v-if="item.isRemove">
              <span
                class="iconBox"
                @click.stop="removeItem('removeItem', item)"
              >
                <svg
                  t="1700107041612"
                  class="svg_icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4162"
                  width="80%"
                  height="80%"
                >
                  <path
                    d="M557.312 513.248l265.28-263.904c12.544-12.48 12.608-32.704 0.128-45.248-12.512-12.576-32.704-12.608-45.248-0.128l-265.344 263.936-263.04-263.84C236.64 191.584 216.384 191.52 203.84 204 191.328 216.48 191.296 236.736 203.776 249.28l262.976 263.776L201.6 776.8c-12.544 12.48-12.608 32.704-0.128 45.248 6.24 6.272 14.464 9.44 22.688 9.44 8.16 0 16.32-3.104 22.56-9.312l265.216-263.808 265.44 266.24c6.24 6.272 14.432 9.408 22.656 9.408 8.192 0 16.352-3.136 22.592-9.344 12.512-12.48 12.544-32.704 0.064-45.248L557.312 513.248z"
                    p-id="4163"
                  ></path>
                </svg>
              </span>
            </span>
          </span>
        </div>
      </swiper-slide>
    </swiper>
    <div
      :class="!isShowPrevBtn ? 'notClick' : ''"
      class="swiper-button-prev"
      @click="clickPrev()"
    >
      <i class="el-icon el-icon-arrow-left"></i>
    </div>
    <div
      :class="!isShowNextBtn ? 'notClick' : ''"
      class="swiper-button-next"
      @click="clickNext()"
    >
      <i class="el-icon el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
  name: 'swiper_broadcastList',
  components: { Swiper, SwiperSlide },
  directives: {
    swiper: directive,
  },
  props: {
    datas: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     dayArr: [
        //       {
        //         id: 'BKBMTEAM5-------------GPA-000100--',
        //         name: '男子预赛A组男子预赛A组男子预赛A组男子预赛A组',
        //         themeNum: '10',
        //         isAct: true,
        //         isRemove: 0, //是否可以删除; 0:默认不可以删；1:新增可以删
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPA-000200--',
        //         name: '男子预赛A组男子预赛A组男子预赛A组男子预赛A组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 0,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPC-000100--',
        //         name: '男子预赛A组男子预赛A组男子预赛A组男子预赛A组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 0,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPC-000200--',
        //         name: '男子预赛C组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 0,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPD-000100--',
        //         name: '男子预赛D组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 0,
        //       },
        //     ],
        //   },
        //   {
        //     dayArr: [
        //       {
        //         id: 'BKBMTEAM5-------------GPD-000200--',
        //         name: '男子预赛D组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 1,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPB-000100--',
        //         name: '男子预赛D组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 1,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPB-000200--',
        //         name: '男子预赛D组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 1,
        //       },
        //       {
        //         id: 'BKBMTEAM5-------------GPC-000300--',
        //         name: '男子预赛D组',
        //         themeNum: '0',
        //         isAct: false,
        //         isRemove: 1,
        //       },
        //     ],
        //   },
        // ]
      },
    },
    currItemId: {
      type: String,
      default: '',
    },
    currGroupOptMap: {
      type: Object,
      default: () => ({
        date: '',
        roomId: '',
        playerItemId: '',
      }),
    },
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isShowPrevBtn: false,
      isShowNextBtn: false,
      initialIndex: 0,
    }
  },
  created() {
    console.debug('swiper:', this.currItemId, this.dateList)
    // this.dateList.forEach((groupItem, groupIndex) => {
    //   groupItem.dayArr.forEach((item) => {
    //     if (this.currItemId == item.id) {
    //       item.isAct = true
    //       this.initialIndex = groupIndex
    //     } else {
    //       item.isAct = false
    //     }
    //   })
    // })
  },
  mounted() {
    this.swiper.slideTo(this.initialIndex, 1000, false)
    this.isShowSwiperBtnHandler(this.swiper)
    this.swiper.on('slideChange', (swiper) => {
      this.isShowSwiperBtnHandler(swiper)
    })
  },
  computed: {
    swiper() {
      console.debug('$swiper:', this.$refs.mySwiper)
      return this.$refs.mySwiper.$swiper
    },
    dateList() {
      let datas = JSON.parse(JSON.stringify(this.datas))
      return datas.map((groupItem, groupIndex) => {
        groupItem.dayArr.forEach((item) => {
          if (this.currItemId == item.id) {
            item.isAct = true
            this.initialIndex = groupIndex
          } else {
            item.isAct = false
          }
        })
        return groupItem
      })
    },
  },
  methods: {
    removeItem(type, item) {
      console.debug(type)
      this.$emit('itemOperate', { type, item })
    },
    editItem(type, item) {
      console.debug(type)
      this.$emit('itemOperate', { type, item })
    },
    shareItem(type, item) {
      //选中当前为 分享到此播单
      this.$emit('itemOperate', { type, item })
    },
    clickPrev() {
      if (!this.isShowPrevBtn) return
      this.swiper.slidePrev()
      this.isShowSwiperBtnHandler(this.swiper)
    },
    clickNext() {
      if (!this.isShowNextBtn) return
      this.swiper.slideNext()
      this.isShowSwiperBtnHandler(this.swiper)
    },
    isShowSwiperBtnHandler(swiper) {
      if (swiper.realIndex == this.dateList.length - 1) {
        this.isShowNextBtn = false
      } else {
        this.isShowNextBtn = true
      }
      if (swiper.realIndex == 0) {
        this.isShowPrevBtn = false
      } else {
        this.isShowPrevBtn = true
      }
    },
    clickItem(item) {
      // this.currItemIdHandle(item.id)
      console.debug('clickItem')
      this.$emit('updateCurrItem', { id: item.id, name: item.name })
    },
    // arabicNum2chinaNum(arabicNum) {
    //   let chinaNum = "";
    //   switch (arabicNum) {
    //     case 1:
    //       chinaNum = "一";
    //       break;
    //     case 2:
    //       chinaNum = "二";
    //       break;
    //     case 3:
    //       chinaNum = "三";
    //       break;
    //     case 4:
    //       chinaNum = "四";
    //       break;
    //     case 5:
    //       chinaNum = "五";
    //       break;
    //     case 6:
    //       chinaNum = "六";
    //       break;
    //     case 7:
    //       chinaNum = "七";
    //       break;
    //     case 8:
    //       chinaNum = "八";
    //       break;
    //     case 9:
    //       chinaNum = "九";
    //       break;
    //     case 10:
    //       chinaNum = "十";
    //       break;
    //     case 11:
    //       chinaNum = "十一";
    //       break;
    //     case 12:
    //       chinaNum = "十二";
    //       break;
    //     case 13:
    //       chinaNum = "十三";
    //       break;
    //     case 14:
    //       chinaNum = "十四";
    //       break;
    //     case 15:
    //       chinaNum = "十五";
    //       break;
    //     case 16:
    //       chinaNum = "十六";
    //       break;
    //     case 17:
    //       chinaNum = "十七";
    //       break;
    //     case 18:
    //       chinaNum = "十八";
    //       break;
    //     case 19:
    //       chinaNum = "十九";
    //       break;
    //     case 20:
    //       chinaNum = "二十";
    //       break;
    //     case 21:
    //       chinaNum = "二十一";
    //       break;
    //     case 22:
    //       chinaNum = "二十二";
    //       break;
    //     case 23:
    //       chinaNum = "二十三";
    //       break;
    //     default:
    //       break;
    //   }
    //   return chinaNum;
    // },
    currItemIdHandle(id) {
      let dateList = this.dateList
      dateList.forEach((groupItem) => {
        groupItem.dayArr.forEach((item) => {
          if (id == item.id) {
            item.isAct = true
            this.$emit('updateCurrItem', id)
          } else {
            item.isAct = false
          }
        })
      })
      this.dateList = dateList
      this.$forceUpdate()
    },
  },
}
</script>

<style lang="scss">
.swiper_broadcastList {
  position: relative;
  height: 7.638vw;
  .swiper-container {
    width: 100%;
    height: 7.638vw;
    overflow: hidden;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 2.083vw;
    height: 7.638vw;
    top: 0;
    margin-top: 0;
    border: 1px solid var(--mixtmt_greyColor0);
    & > i {
      font-size: 1.11vw;
      color: var(--mixtmt_greyColor0);
    }
    &::after {
      content: '';
    }
    &:hover {
      background-color: var(--mixtmt_broadcast_swiper_actBg);
      & > i {
        color: var(--mixtmt_whiteColor);
      }
    }
    &.notClick {
      &:hover {
        cursor: default;
        background: none;
        & > i {
          color: var(--mixtmt_greyColor0);
        }
      }
    }
  }
  .swiper-button-next {
    right: 0;
    border-radius: 0 0.694vw 0.694vw 0;
  }
  .swiper-button-prev {
    left: 0;
    border-radius: 0.694vw 0 0 0.694vw;
  }

  .swiper-slide {
    display: flex;
    display: -webkit-flex;
    padding: 0 2.778vw;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 7.638vw;
  }
  .date_item {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.694vw;
    width: calc(20% - 0.694vw);
    height: 7.638vw;
    border-radius: 0.278vw;
    color: var(--mixtmt_greyColor2);
    /* border: 1px solid var(--mixtmt_greyColor0); */
    background-color: var(--mixtmt_broadcast_swiper_bg);

    .date_item_main {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      height: 100%;
      padding: 1.38vw 1.11vw 0 1.11vw;
      .itemMain_matchName {
        width: 100%;
        font-size: 1.11vw;
        font-weight: bold;
        line-height: 1.38vw;
        text-align: left;
        height: 2.78vw;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: var(--mixtmt_greyColor2);
      }
      .itemMain_themeNum {
        width: 100%;
        font-size: 0.833vw;
        line-height: 1.68vw;
        text-align: left;
        color: var(--mixtmt_greyColor4);
      }
      .itemMain_opareBtnRow {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        .opareBtnRow_left {
          width: calc(100% - 1.11vw);
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 0.833vw;
          line-height: 1.11vw;
          text-align: left;
          color: var(--mixtmt_greyColor4);
          .opareBtnRow_shareIcon {
            position: relative;
            width: 0.972vw;
            height: 0.972vw;
            border-radius: 50%;
            border: 1px solid var(--mixtmt_greyColor4);
            background-color: var(--mixtmt_whiteColor);
            &.act {
              .iconBox {
                opacity: 1;
              }
            }
            .iconBox {
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              svg.svg_icon {
                fill: var(--mixtmt_broadcast_swiper_actBg);
              }
            }
          }
          .opareBtnRow_shareText {
            padding: 0 0.416vw;
          }
        }
        .opareBtnRow_right {
          width: 1.11vw;
          height: 1.11vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 0.972vw;
          line-height: 1.11vw;
          text-align: left;
          border-radius: 50%;
          color: var(--mixtmt_greyColor4);
          .iconBox {
            width: 100%;
            height: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            svg.svg_icon {
              fill: var(--mixtmt_mainColor8);
            }
          }
        }
      }
      .itemMain_removeBtn {
        display: none;
        position: absolute;
        right: 0.32vw;
        top: 0.32vw;
        z-index: 10;
        width: 1.11vw;
        height: 1.11vw;
        /* background-color: var(--mixtmt_whiteColor); */
        border: 1px solid var(--mixtmt_whiteColor);
        border-radius: 50%;
        .iconBox {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          svg.svg_icon {
            fill: var(--mixtmt_whiteColor);
          }
        }
      }
    }
    &.act,
    &:hover {
      cursor: pointer;
      background-color: var(--mixtmt_broadcast_swiper_actBg);
      .date_item_main {
        .itemMain_matchName {
          color: var(--mixtmt_whiteColor);
        }
        .itemMain_themeNum,
        .opareBtnRow_left {
          color: var(--mixtmt_greyColor11);
        }
        .itemMain_opareBtnRow {
          .opareBtnRow_left {
            .opareBtnRow_shareIcon {
              &.act {
                border: 1px solid var(--mixtmt_whiteColor);
                .iconBox {
                  opacity: 1;
                }
              }
            }
          }
          .opareBtnRow_right {
            border: 1px solid var(--mixtmt_whiteColor);
            .iconBox {
              svg.svg_icon {
                fill: var(--mixtmt_whiteColor);
              }
            }
            &:hover {
              background-color: var(--mixtmt_whiteColor);
              border-radius: 50%;
              .iconBox {
                svg.svg_icon {
                  fill: var(--mixtmt_mainColor8);
                }
              }
            }
          }
        }
        .itemMain_removeBtn {
          display: block;
          &:hover {
            background-color: var(--mixtmt_whiteColor);
            border-radius: 50%;
            .iconBox {
              svg.svg_icon {
                fill: var(--mixtmt_mainColor8);
              }
            }
          }
        }
      }
    }

    &.act {
      cursor: pointer;
      background-color: var(--mixtmt_broadcast_swiper_actBg);
      .date_item_main {
        .itemMain_opareBtnRow {
          .opareBtnRow_left {
            .opareBtnRow_shareIcon {
              &.act {
                border: 1px solid var(--mixtmt_whiteColor);
                .iconBox {
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
    /* &.noAct {
          .item_week {
            transform: translateX(-20%);
            -webkit-transform: translateX(-20%);
          }
        } */
  }
}
</style>
